module.exports = __webpack_public_path__ + "static/img/IMG_20240629_120750.8275c912.jpg";